module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-summer.33954ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-summer.png
// module id = /9H0
// module chunks = 0